<div class="p-g form-container" style="width: 30vw;min-width: 350px;">
  <form [formGroup]='otpForm'>
    <div class="p-g-12 p-0">
      <div class="form-field p-g-12 pl-0 pr-0">
        <div class="form-label">
          <label for="username" translate>label_otp_msg</label>
        </div>
        <div class="form-control">
          <input formControlName="otpInput" type="text" pInputText />
        </div>
        <div class="form-errors" *ngIf="otpForm.controls.otpInput.errors  && (otpForm.controls.otpInput.dirty || otpForm.controls.otpInput.touched)">
          <div [hidden]="!otpForm.controls.otpInput.errors.required" translate>
             label_please_enter_otp
          </div>
        </div>
      </div>
    </div>
    <div class="form-buttons p-g-12 p-g-nopad">
      <button class="negative-button mr-0" pButton type="button" icon="fa fa-close" label="Cancel" (click)="closeEditForgot($event)"></button>
      <button pButton type="button" [label]="'label_send' | translate" icon="fa fa-check" [disabled]="!otpForm.valid" (click)="changePassword($event)"></button>
    </div>
    <div class="resend-container p-g-12 p-g-nopad">
      <span class="timer-text" *ngIf="isResendDisabled">
        Resend OTP in {{ countdownDisplay }}
      </span>
      <a
        class="resend-link"
        href=""
        (click)="resendOtp($event)"
        [attr.aria-disabled]="isResendDisabled || isResendProcessing"
        [style.pointer-events]="(isResendDisabled || isResendProcessing) ? 'none' : 'auto'"
        [style.opacity]="(isResendDisabled || isResendProcessing) ? 0.6 : 1"
      >
        {{ 'label_resend' | translate }} OTP
      </a>
    </div>
  </form>
</div>
